import { NgModule } from '@angular/core';
import { OvGenericModule } from '@ov-suite/ui';
import { Area } from '@ov-suite/models-admin';

@NgModule({
  imports: [
    OvGenericModule.forRoot({
      entity: Area,
      api: 'adminlink',
      createTitle: 'Area',
      route: ['area'],
      tableTitle: 'Area',
      permissionId: 902,
    }),
  ],
})
export class AreaModule {}
